import { defineStore } from 'pinia';

export const useLoaderStore = defineStore('global-loader', {
  state: () => ({
    loading: false,
  }),
  actions: {
    toggleLoader (loading = false) {
      this.loading = loading;
    },
  },
});
